<template>
  <form-field-select
    :label="label"
    :value="value"
    :validation-errors="validationErrors"
    :size="size"
    @change="handleInput"
    :help-text="helpText"
  >
    <option
      v-for="(user, index) in users"
      :key="index"
      :value="user.id"
    >{{ user.full_name }}</option>
  </form-field-select>
</template>

<script>
export default {
  name: "FormFieldSelectUsers",
  props: {
    value: {},
    selectableUsers: {
      type: Array,
    },
    label: {
      type: String,
      default: 'User'
    },
    validationErrors: {
      type: [String, Array, undefined]
    },
    hasEmptyOption: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'is-small'
    },
    helpText: {
      type: String
    },
  },
  computed: {
    users() {
      let users = (this.selectableUsers) ? [...this.selectableUsers] : [...this.$store.getters.activeUsers];

      if (this.hasEmptyOption) {
        return [
          { id: null, full_name: 'None' },
          ...users
        ]
      }

      return users;
    },
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
      this.$emit('change', val);
      this.$emit('selected', val);
    },
  }
}
</script>

<style scoped>

</style>
